var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTextBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299.297,
    xmlns: "http://www.w3.org/2000/svg",
    height: 78.209,
    id: "screenshot-4c13bd60-082e-80ca-8002-442b4b331483",
    viewBox: "25 -35 299.297 78.209",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-442b4b331483",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-442b4b331484",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-442b4b331486"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-442b4b331486"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M72.228,10.351C72.257,10.436,72.286,10.520,72.315,10.605L72.228,10.351ZM39.068,57.000L39.068,57.000ZL38.405,57.000C25.016,56.745,13.450,48.976,7.751,37.733L15.403,35.680C19.970,43.663,28.565,49.047,38.405,49.047L38.405,56.994M72.296,10.605L72.296,10.605Z",
    style: {
      fill: "rgb(248, 250, 252)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-442b4b331487"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-442b4b331487"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.270270270270316,
    ry: 9.279069767441797,
    cx: 9.270270270270316,
    cy: 17.232558139535286,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "rgb(248, 250, 252)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-442b4b331488"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-442b4b331488"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M47.676,0.000C57.178,0.000,64.892,7.722,64.892,17.233L64.892,34.465L56.946,34.465L56.946,31.753C54.269,33.469,51.088,34.465,47.676,34.465C38.174,34.465,30.459,26.743,30.459,17.233C30.459,7.722,38.174,0.000,47.676,0.000ZM47.676,7.953C42.559,7.953,38.405,12.111,38.405,17.233C38.405,22.354,42.559,26.512,47.676,26.512C52.792,26.512,56.946,22.354,56.946,17.233C56.946,12.111,52.792,7.953,47.676,7.953Z",
    style: {
      fill: "rgb(248, 250, 252)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-442b4b331485"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-442b4b331485"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M259.568,15.907L263.541,15.907L263.541,34.465L259.568,34.465L259.568,15.907ZM157.595,0.000C167.096,0.000,174.811,7.722,174.811,17.233C174.811,26.743,167.096,34.465,157.595,34.465C148.093,34.465,140.378,26.743,140.378,17.233C140.378,7.722,148.093,0.000,157.595,0.000ZM157.595,3.977C150.285,3.977,144.351,9.916,144.351,17.233C144.351,24.549,150.285,30.488,157.595,30.488C164.904,30.488,170.838,24.549,170.838,17.233C170.838,9.916,164.904,3.977,157.595,3.977ZM91.378,0.000C100.880,0.000,108.595,7.722,108.595,17.233C108.595,26.743,100.880,34.465,91.378,34.465C81.876,34.465,74.162,26.743,74.162,17.233C74.162,7.722,81.876,0.000,91.378,0.000ZM91.378,3.977C84.069,3.977,78.135,9.916,78.135,17.233C78.135,24.549,84.069,30.488,91.378,30.488C98.688,30.488,104.622,24.549,104.622,17.233C104.622,9.916,98.688,3.977,91.378,3.977ZM290.027,15.907L294.000,15.907L294.000,34.465L290.027,34.465L290.027,15.907ZM234.405,0.000C243.907,0.000,251.622,7.722,251.622,17.233C251.622,26.743,243.907,34.465,234.405,34.465C224.904,34.465,217.189,26.743,217.189,17.233C217.189,7.722,224.904,0.000,234.405,0.000ZM234.405,3.977C227.096,3.977,221.162,9.916,221.162,17.233C221.162,24.549,227.096,30.488,234.405,30.488C241.715,30.488,247.649,24.549,247.649,17.233C247.649,9.916,241.715,3.977,234.405,3.977ZM247.649,15.907L251.622,15.907L251.622,34.465L247.649,34.465L247.649,15.907ZM276.784,3.733C269.475,3.733,263.541,9.310,263.541,16.178L263.541,26.512C261.060,23.708,259.568,20.106,259.568,16.178C259.568,7.249,267.282,0.000,276.784,0.000C286.286,0.000,294.000,7.249,294.000,16.178C294.000,20.106,292.508,23.708,290.027,26.512L290.027,16.178C290.027,9.310,284.093,3.733,276.784,3.733ZM74.162,15.907L78.135,15.907L78.135,45.070L74.162,45.070L74.162,15.907ZM129.784,4.063C124.291,5.300,120.152,10.684,120.152,17.130L120.152,28.202C117.897,25.198,116.541,21.339,116.541,17.130C116.541,8.470,122.287,1.284,129.784,0.000L129.784,4.063ZM116.541,17.130L120.152,17.130L120.152,34.465L116.541,34.465L116.541,17.130ZM182.044,0.000L177.459,0.000L197.324,34.465L217.189,0.000L212.605,0.000L197.324,26.512L182.044,0.000Z",
    style: {
      fill: "rgb(248, 250, 252)",
      fillOpacity: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextBottom);
export default __webpack_public_path__ + "static/media/logo-text-bottom.dd410db315a7581b85eb320450c86db9.svg";
export { ForwardRef as ReactComponent };